module.exports = __webpack_public_path__ + "img/dfjw1.adf64f3f.jpg";